import React from 'react'
import { formatSalesValue } from '../../utils/formatUtils'
import Piechart from '../Charts/Piechart'

const SidebarDetails = ({
    dineinTabs,
    startBillNum,
    endBillNum,
    revenuePerGuest,
    adjustedNetTotal,
    adjustedNetDineIn,
    adjustedNetTab,
    isServiceChecked,
    FoodBeverageSum,
    paymentStatus,
    totalSplitCreditCard,
    totalSplitCash,
    totalSplitMobilePayment,
    setShowModal,
    handleExport,
}) => {
    return (
        <div>
            {!dineinTabs?.error && (
                <div className="text-base">
                    {/* Action buttons */}
                    <div className="flex justify-end p-2 mb-2">
                        {/* <button
                            onClick={() => setShowModal(true)}
                            className="rounded-md border border-indigo-300 bg-white px-3 py-1.5 text-xs font-medium text-indigo-600 hover:bg-indigo-50 transition-colors"
                        >
                            Export
                        </button> */}
                        <button
                            onClick={handleExport}
                            className="rounded-md bg-indigo-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-indigo-700 transition-colors"
                        >
                            Export
                        </button>
                    </div>

                    <div className="space-y-2 px-3 py-2.5">
                        <div>
                            <label>
                                <span>Starting Bill No : </span>
                                {startBillNum || "-"}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Ending Bill No : </span>
                                {endBillNum || "-"}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Total No. of Guest : </span>
                                {dineinTabs.TotalGuests || "-"}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Revenue Per Guest : </span>
                                {formatSalesValue(revenuePerGuest) || "-"}
                            </label>
                        </div>
                    </div>

                    <hr className="hr-line" />

                    <div className="space-y-2 px-3 py-2.5">
                        <label>
                            <span>Total Sales : </span>
                            {formatSalesValue(dineinTabs.TOTALSALES)}
                        </label>
                        <div>
                            <label>
                                <span>Dine-In : </span>
                                {formatSalesValue(dineinTabs.DineInSALES)}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Take-away : </span>
                                {!dineinTabs.TabSALES ? "0" : formatSalesValue(dineinTabs.TabSALES)}
                            </label>
                        </div>
                    </div>

                    <hr className="hr-line" />

                    {/* Net Sales — adjusted when isServiceChecked */}
                    <div className="space-y-2 px-3 py-2.5">
                        <label>
                            <span>Total Net Sales : </span>
                            {formatSalesValue(adjustedNetTotal)}
                        </label>
                        <div>
                            <label>
                                <span>Dine-In : </span>
                                {formatSalesValue(adjustedNetDineIn)}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Take-away : </span>
                                {adjustedNetTab === 0 ? "0" : formatSalesValue(adjustedNetTab)}
                            </label>
                        </div>
                    </div>

                    <hr className="hr-line" />

                    <div className="space-y-2 px-3 py-2.5">
                        <label>
                            <span>Total VAT: </span>
                            {formatSalesValue(dineinTabs.TotalVat)}
                        </label>
                        <div>
                            <label>
                                <span>Dine-In : </span>
                                {formatSalesValue(dineinTabs.DineInVAT)}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Take-away : </span>
                                {(dineinTabs.TabVAT = dineinTabs.TabVAT ?? "0")}
                            </label>
                        </div>
                    </div>

                    <hr className="hr-line" />

                    {/* Service Charge — only shown when isServiceChecked */}
                    {isServiceChecked && (
                        <>
                            <div className="space-y-2 px-3 py-2.5">
                                <label>
                                    <span>Service Charge : </span>
                                    {formatSalesValue(dineinTabs.TotalServiceCharge)}
                                </label>
                                <div>
                                    <label>
                                        <span>Dine-In : </span>
                                        {formatSalesValue(dineinTabs.DineInServiceCharge)}
                                    </label>
                                </div>
                                <div>
                                    <label>
                                        <span>Take-away : </span>
                                        {(dineinTabs.TabServiceCharge = dineinTabs.TabServiceCharge ?? "0")}
                                    </label>
                                </div>
                            </div>
                            <hr className="hr-line" />
                        </>
                    )}

                    <div className="py-3 px-1.5">
                        <Piechart
                            FoodBeverageSum={FoodBeverageSum}
                            dineinTabs={dineinTabs}
                        />
                    </div>

                    <hr className="hr-line" />

                    <div className="space-y-2 px-3 py-2.5">
                        <label>
                            <span>Food Sale : </span>
                            {formatSalesValue(dineinTabs.FoodSale)}
                        </label>
                        <div>
                            <label>
                                <span>Beverage Sale : </span>
                                {formatSalesValue(dineinTabs.BeverageSale)}
                            </label>
                        </div>
                        <div>
                            <label>
                                <span>Others : </span>
                                {formatSalesValue(dineinTabs.OtherSale)}
                            </label>
                        </div>
                    </div>
                    <hr className="hr-line" />
                </div>
            )}

            {!paymentStatus?.error && (
                <div className="space-y-2 px-3 py-2.5">
                    <div>
                        <label>
                            <span>Credit Card : </span>
                            {formatSalesValue(Number(paymentStatus.CreditCard) + totalSplitCreditCard)}
                        </label>
                    </div>
                    <div>
                        <label>
                            <span>Cash : </span>
                            {formatSalesValue(Number(paymentStatus.Cash) + totalSplitCash)}
                        </label>
                    </div>
                    <div>
                        <label>
                            <span>Mobile Payment : </span>
                            {formatSalesValue(
                                Number(paymentStatus.MobilePayment) + totalSplitMobilePayment
                            )}
                        </label>
                    </div>
                    <div>
                        <label>
                            <span>Credit Sale: </span>
                            {formatSalesValue(paymentStatus.Credit)}
                        </label>
                    </div>
                    <div>
                        <label>
                            <span>Complimentary : </span>
                            {formatSalesValue(paymentStatus.Complimentary)}
                        </label>
                    </div>
                    <div>
                        <label>
                            <span>Discount Amount : </span>
                            {formatSalesValue(dineinTabs.DiscountAmountSum)}
                        </label>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SidebarDetails